import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import React, { useCallback, useMemo, useState } from 'react'

import { useLazyGetAllCSNotesQuery } from 'api/notes/configuredServiceNotesCrud'
import { ReactComponent as ServiceNoteIcon } from 'assets/note/ServiceNote.svg'
import CombinedNotesDialog from 'components/notes/combined/CombinedNotesDialog'
import StyledBadge from 'components/notes/common/StyledBadge'
import ViewNotesPopover from 'components/notes/common/ViewNotesPopover'
import { NOTE_TYPES } from 'settings/constants/note'
import T from 'T'

const StyledBadgeUntyped = StyledBadge as React.ElementType
const ViewNotesPopoverUntyped = ViewNotesPopover as React.ElementType

type CSNotesBadgeProps = {
  configuredServiceId?: string
  notesCount?: number
}

const CSNotesBadge = ({ configuredServiceId, notesCount = 0 }: CSNotesBadgeProps) => {
  const [viewCSNotesPopoverAnchorEl, setViewCSNotesPopoverAnchorEl] = useState<HTMLElement | null>(null)
  const [isOpenCSNotesDialog, setIsOpenCSNotesDialog] = useState(false)
  const hasNotes = useMemo(() => notesCount > 0, [notesCount])

  const handleViewCSNotesPopoverOpen = useCallback((event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setViewCSNotesPopoverAnchorEl(event.currentTarget)
  }, [])
  const handleViewCSNotesPopoverClose = useCallback(() => setViewCSNotesPopoverAnchorEl(null), [])
  const handleOpenCSNotesDialog = useCallback(() => setIsOpenCSNotesDialog(true), [])
  const handleCloseCSNotesDialog = useCallback(() => setIsOpenCSNotesDialog(false), [])

  return (
    <>
      <Tooltip arrow disableInteractive disableHoverListener={hasNotes} placement="bottom" title={`${T.SERVICE_NOTE}s`}>
        <IconButton
          size="small"
          onClick={handleOpenCSNotesDialog}
          {...(hasNotes && {
            onMouseEnter: handleViewCSNotesPopoverOpen,
            onMouseLeave: handleViewCSNotesPopoverClose,
          })}
        >
          <StyledBadgeUntyped badgeContent={notesCount}>
            <ServiceNoteIcon />
          </StyledBadgeUntyped>
        </IconButton>
      </Tooltip>
      <ViewNotesPopoverUntyped
        anchorEl={viewCSNotesPopoverAnchorEl}
        id={configuredServiceId}
        position="right"
        useLazyGetAllNotesQuery={useLazyGetAllCSNotesQuery}
        onClose={handleViewCSNotesPopoverClose}
      />
      {isOpenCSNotesDialog && (
        <CombinedNotesDialog
          open
          configuredServiceId={configuredServiceId}
          defaultTab={NOTE_TYPES.CONFIGURED_SERVICE}
          onClose={handleCloseCSNotesDialog}
        />
      )}
    </>
  )
}

export default CSNotesBadge
